export enum NetworkType {
    NetworkTypeOT = 'OT',
    NetworkTypeCrew = 'Crew',
    NetworkTypeBusiness = 'Business',
    NetworkTypeOther = 'Other',
}
